/**
 * 文件说明:
 *
 * Page text title  Header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useLayoutEffect, useState} from 'react'
import ContentHeader from 'components/hz-layout/content-header'
import {useRefData} from 'hooks'
import {cloneDeep} from 'lodash'

const TitleHeader = memo((props) => {
    const {
        pageHeaderOption: initPageHeaderOption,
        setHzHeaderHelp,
        PageComponent,
        pageProps,
        restoreHzHeaderHelp,
        useTitle,
    } = props

    const hzDocTitle = useTitle(initPageHeaderOption?.title, initPageHeaderOption?.defaultTitle)

    const [pageHeaderOption, setPageHeaderOption] = useState(() => {
        const newPageHeaderOption = cloneDeep(initPageHeaderOption ?? {})

        newPageHeaderOption.content = newPageHeaderOption.content ?? {}
        newPageHeaderOption.content.title = hzDocTitle

        return newPageHeaderOption
    })

    const {title, defaultTitle, hzHelp, autoCrateComponent = false, ...restProps} = pageHeaderOption

    const getRefData = useRefData({
        setHzHeaderHelp,
        restoreHzHeaderHelp,
        hzHelp,
    })

    useLayoutEffect(() => {
        getRefData()?.setHzHeaderHelp?.(getRefData()?.hzHelp)
        return () => {
            getRefData()?.restoreHzHeaderHelp?.()
        }
    }, [])

    if (autoCrateComponent) {
        return (
            <PageComponent
                {...pageProps}
                hzDocTitle={hzDocTitle}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
                pageHeaderOption={pageHeaderOption}
                setPageHeaderOption={setPageHeaderOption}
                ContentHeader={ContentHeader}
                contentHeaderOption={{...restProps}}
            />
        )
    }

    return (
        <>
            <ContentHeader {...restProps} />
            <PageComponent
                {...pageProps}
                hzDocTitle={hzDocTitle}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
                pageHeaderOption={pageHeaderOption}
                setPageHeaderOption={setPageHeaderOption}
            />
        </>
    )
})

export default TitleHeader
